document.addEventListener("DOMContentLoaded", () => {

    // If there is more than one .control-whatson-list, we need to setup the script to handle it separately
    const whatsOnListControls = document.querySelectorAll('.control-whatson-list');
    whatsOnListControls.forEach((whatsOnListControlDoc) => {

        // Get all the fields for filtering the whatson list
        const hotelInput = whatsOnListControlDoc.querySelector('#whatson-filter-hotel');
        const destinationInput = whatsOnListControlDoc.querySelector('#whatson-filter-destination');
        const categoryInput = whatsOnListControlDoc.querySelector('#whatson-filter-category');

        const setInputValue = (input, value) => {
            if (input) input.value = value;
        };

        // Show only hotels belonging to the selected destination. The empty option
        // remains available so the hotel filter can always be cleared.
        const updateHotelOptions = (clearInvalidSelection = true) => {
            if (!hotelInput) return;

            const selectedDestination = destinationInput?.value.trim() ?? '';
            const hotelOptions = hotelInput.querySelectorAll('option');
            let selectedHotelIsValid = !hotelInput.value;

            hotelOptions.forEach((hotelOption) => {
                const isAllHotelsOption = !hotelOption.value;
                const belongsToDestination = !selectedDestination
                    || isAllHotelsOption
                    || hotelOption.dataset.destination === selectedDestination;

                hotelOption.hidden = !belongsToDestination;

                if (hotelOption.value === hotelInput.value) {
                    selectedHotelIsValid = belongsToDestination;
                }
            });

            if (clearInvalidSelection && !selectedHotelIsValid) {
                setInputValue(hotelInput, '');
            }
        };

        const scrollToAnchor = () => {
            whatsOnListControlDoc.querySelectorAll('.whatson-card.show-card').forEach((whatsOnCard) => {
                whatsOnCard.classList.remove('show-card');
            });

            const whatsOnAnchor = window.location.hash.slice(1);
            if (!whatsOnAnchor) return;

            const whatsOnElement = whatsOnListControlDoc.querySelector(`.whatson-card.${CSS.escape(whatsOnAnchor)}`);
            if (!whatsOnElement) return;

            if (whatsOnElement.classList.contains('hidden-card')) {
                whatsOnElement.classList.add('show-card');
            }

            window.requestAnimationFrame(() => {
                const headerOffset = 100;
                const elementTop = whatsOnElement.getBoundingClientRect().top + window.scrollY;

                window.scrollTo({
                    top: elementTop - headerOffset,
                    behavior: 'smooth'
                });
            });
        };

        // Function that takes query string parameters for the filters and applies them to the whatson list, hiding any whatson cards that don't match the filters. The function also updates the filter inputs to reflect the applied filters.
        const applyFiltersFromQueryString = (queryString) => {
            const urlParams = new URLSearchParams(queryString);
            const destination = urlParams.get('destination') ?? '';
            const hotel = urlParams.get('hotels') ?? '';
            const category = urlParams.get('category') ?? '';

            setInputValue(destinationInput, destination);
            updateHotelOptions(false);
            setInputValue(hotelInput, hotel);
            updateHotelOptions();
            setInputValue(categoryInput, category);

            applyFilters(whatsOnListControlDoc);

            scrollToAnchor();
        };

        window.addEventListener('hashchange', scrollToAnchor);

        // Setup the filter button to toggle the filter row visibility
        whatsOnListControlDoc.querySelector('.filter-button')?.addEventListener('click', event => {
            event.preventDefault();
            whatsOnListControlDoc.querySelector('.filter-row')?.classList.toggle('active');
        });

        // Setup the filter close button to hide the filter row
        whatsOnListControlDoc.querySelector('.filter-close')?.addEventListener('click', event => {
            event.preventDefault();
            whatsOnListControlDoc.querySelector('.filter-row')?.classList.remove('active');
        });

        const syncEmptyState = (whatsOnListControl) => {
            const emptyState = whatsOnListControl?.querySelector('.whatson-list-empty');
            if (emptyState) emptyState.hidden = !!whatsOnListControl.querySelector('.whatson-card:not(.hidden-card), .whatson-card.show-card');
        };

        const applyFilters = (whatsOnListControl) => {
            if (!whatsOnListControl) return;

            // If the filter-row is active, close it after applying the filters
            whatsOnListControl.querySelector('.filter-row')?.classList.remove('active');

            whatsOnListControl.querySelectorAll('.whatson-card')?.forEach((whatsOnCard) => {
                let isMatch = true;

                // Apply hotel, destination, and category type filtering.
                const selectedHotel = hotelInput?.value.trim() ?? '';
                const selectedDestination = destinationInput?.value.trim() ?? '';
                const selectedCategory = categoryInput?.value.trim() ?? '';

                if (selectedHotel || selectedDestination || selectedCategory) {
                    isMatch = isMatch
                        && (!selectedHotel || whatsOnCard.dataset.hotels.includes(selectedHotel))
                        && (!selectedDestination || whatsOnCard.dataset.destinations.includes(selectedDestination))
                        && (!selectedCategory || whatsOnCard.dataset.categories.includes(selectedCategory));
                }

                whatsOnCard.classList.toggle('hidden-card', !isMatch);
            });

            syncEmptyState(whatsOnListControl);
        };

        // Function to reset all filters and show all whatson cards.
        const resetFilters = (whatsOnListControl) => {
            if (!whatsOnListControl) return;

            // Remove the value from hotels, destinations, and category type inputs
            setInputValue(hotelInput, '');
            setInputValue(destinationInput, '');
            setInputValue(categoryInput, '');
            updateHotelOptions(false);

            whatsOnListControl.querySelectorAll('.whatson-card')?.forEach((whatsOnCard) => {
                whatsOnCard.classList.remove('hidden-card');
            });

            syncEmptyState(whatsOnListControl);
        };

        const updateUrlFromFilters = () => {
            const url = new URL(window.location.href);
            const filters = {
                destination: destinationInput?.value.trim() ?? '',
                hotels: hotelInput?.value.trim() ?? '',
                category: categoryInput?.value.trim() ?? '',
            };

            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    url.searchParams.set(key, value);
                } else {
                    url.searchParams.delete(key);
                }
            });

            window.history.replaceState({}, '', url);
        };

        destinationInput?.addEventListener('change', () => {
            updateHotelOptions();
        });

        updateHotelOptions();


        // Get the query string parameters from the current URL and apply them to the whatson list
        const currentQueryString = window.location.search;
        if (currentQueryString || window.location.hash) {
            applyFiltersFromQueryString(currentQueryString);
        }

        whatsOnListControlDoc.querySelector('.whatson-list-clear-search')?.addEventListener('click', (event) => {
            event.preventDefault();
            resetFilters(whatsOnListControlDoc);
        });

        whatsOnListControlDoc.querySelector('.whatson-list-filter-submit button')?.addEventListener('click', () => {
            applyFilters(whatsOnListControlDoc);
            updateUrlFromFilters();
        });

        syncEmptyState(whatsOnListControlDoc);

        applyFilters(whatsOnListControlDoc);

        // Set up the details popup for each What's On card.
        whatsOnListControlDoc.querySelectorAll('.whatson-popup-link').forEach((popupLink) => {
            const openButton = popupLink.querySelector('button.btn-txt');
            const overlay = popupLink.querySelector('.whatson-popup-overlay');
            const popup = popupLink.querySelector('.popup-content');
            const closeButton = popupLink.querySelector('.whatson-popup-close');

            if (!openButton || !popup) return;

            const closePopup = () => {
                popup.hidden = true;
                if (overlay) overlay.hidden = true;
                openButton.setAttribute('aria-expanded', 'false');
                document.body.classList.remove('whatson-popup-open');
            };

            openButton.addEventListener('click', () => {
                // Close any other open card popup first.
                whatsOnListControlDoc.querySelectorAll('.whatson-popup-link').forEach((otherPopupLink) => {
                    if (otherPopupLink !== popupLink) {
                        otherPopupLink.querySelector('.popup-content')?.setAttribute('hidden', '');
                        otherPopupLink.querySelector('.whatson-popup-overlay')?.setAttribute('hidden', '');
                        otherPopupLink.querySelector('button.btn-txt')?.setAttribute('aria-expanded', 'false');
                    }
                });

                popup.hidden = false;
                if (overlay) overlay.hidden = false;
                openButton.setAttribute('aria-expanded', 'true');
                document.body.classList.add('whatson-popup-open');
                closeButton?.focus();
            });

            closeButton?.addEventListener('click', closePopup);
            overlay?.addEventListener('click', closePopup);
        });
    });
});
